<template>
	<div class="solution-categroy">
		<div class="categroy">
			<div class="group" v-for="group in categroy.list" :key="group.id">
				<div class="group-title">
					<img class="icon" :src="getImageUrl(group.icon)" />
					<span class="name">{{ group.dictLabel }}</span>
				</div>
				<div class="group-item" v-for="item in group.children" :key="item.id" @click="linkTo(item)">
					<div class="imgs"><img class="icon" :src="item.icon" /></div>
					<div class="text">
						<div class="name">{{ item.title }}</div>
						<div class="desc">{{ item.subtitle }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="follow">
			<div>
				<img class="img" src="@/assets/images/code1.png" />
				<div class="txt">
					联系我们<br/>了解更多
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup name="PageHeader">
import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getHeaderTop } from '@/api/home'
import { checkDevice, getImageUrl } from '@/utils/index'
import { getSolutionPageApi } from '@/api/module/solution'
import { getDictApi } from '@/api/module/common'
import { getResolutionListApi } from '@/api/module/case'
import { apiImgUrl } from "@/utils/index";

const router = useRouter();
const route = useRoute();
const emits = defineEmits(["update:show"]);
const props = withDefaults(
	defineProps<{
    show?: boolean;
  }>(), {
  show: false // 菜单导航是否显示
});
const categroy: any = reactive({
	list: [
		/* {
			id: 1,
			title: '政府',
			icon: "meun_icon_zhengfu.png",
			children: [
				{id: 2, title: '公共数据开发利用', icon: 'meun_product_img1.png', desc:"全链路数据资产平台"},
				{id: 3, title: '可信数据空间(城市)', icon: 'meun_product_img2.png', desc:"可信流通，协同治理"}
			]
		},
		{
		  id: 3,
			title: '农业',
			icon: "meun_icon_nongye.png",
			children: [
				{id: 4, title: '温氏农业',icon: 'meun_product_img5.png', desc:"全链路数据资产平台"},
				{id: 5, title: '温氏家禽',icon: 'meun_product_img4.png', desc:"可信流通，协同治理"},
			]
		},
		{
			id: 6,
			title: '央国企',
			icon: "meun_icon_yangguoqi.png",
			children: [
				{id: 7, title: '数据资产入表', icon: 'meun_product_img1.png', desc:"全链路数据资产平台"}
			]
		},
		{
		  id: 8,
			title: '制造业',
			icon: "meun_icon_zhizaoye.png",
			children: [
				{id: 9, title: '数字化转型',icon: 'meun_product_img5.png', desc:"全链路数据资产平台"},
			]
		} */
	]
});
const linkTo = (item:any) => {
	router.push("/solution?id="+item.id);
	if(checkDevice()){
		emits("update:show", false);
	}
}

const getPage = () => {
	getResolutionListApi().then((res: any) => {
    if (res && res.data) {
      res.data.forEach((item: any) => {
        item.icon = apiImgUrl(item.icon);
      });
      if (categroy.list.length) {
        categroy.list = categroy.list.map((group: any) => {
          const matchingItems = res.data.filter(
            (item: any) => item.resolutionType == group.dictValue
          );
          return {
            ...group,
            children: matchingItems,
          };
        });
      }
    }
  });
};
//获取分类
const getCategroy = async () => {
  await getDictApi("resolution_type").then((res: any) => {
    if (res && res.data.length) {
      categroy.list = res.data.map((item: any) => {
        item.icon = "meun_icon_shuju.png";
        return item;
      });
    }
  });
};
onMounted(async () => {
  await getCategroy();
  await getPage();
});
</script>

<style scoped lang="scss">
.solution-categroy {
	display: flex;
	padding: 30px 100px;
	.categroy {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
	}
	.group {
		width: calc(50% - 105px);
		border-right: 1px solid #eee;
		margin-right: 50px;
		padding-right: 50px;
		padding-bottom: 30px;
		.group-title {
			display: flex;
			align-items: center;
			.icon {
				width: 20px;
				img {
					display: block;
					max-width: 100%;
				}
			}
			.name {
				margin-left: 10px;
				line-height: 1;
				font-size: 18px;
				font-weight: 600;
			}
		}
		.group-item {
			cursor: pointer;
			display: flex;
			align-items: center;
			padding: 20px 0;
			border-bottom: 1px solid #eee;
			.imgs {
				width: 60px;
				height: 60px;
				background-color: #ecf4ff;
				margin-right: 20px;
				img {
					display: block;
					width: 100%;
				}
			}
			.text {
				.name {
					font-size: 17px;
					font-weight: 500;
					color: #000;
				}
				.desc {
					margin-top: 5px;
					font-size: 15px;
					color: #999;
				}
			}
		}
		
	}
	.follow {
		padding:30px 100px 0 ;
		width:180px;
		.img {
			display: block;
			width: 100%;
			height: auto;
			margin: auto;
		}
		.txt {
			margin-top: 10px;
			text-align: center;
			font-size: 18px;
			line-height: 1.8;
			font-weight: 600;
		}
	}
}
@media screen and (max-width: 1024px) {
	.solution-categroy {
		display: block;
		padding: 30px;
		border: 0;
		margin: 0;
		.group {
			width: auto;
			margin: 0 0 40px 0;
			padding: 0 0 20px 0;
			border-right: 0;
			border-bottom: 1px solid #eee;
			.group-title {
				margin-bottom: 20px;
				.icon {
					width: 32px;
				}
				.name {
					font-size: 32px;
				}
			}
			.group-item {
				.imgs {
					width: 88px;
					height: 88px;
					margin-right: 30px;
					img {
						width: 100%;
					}
				}
				.text {
					.name {
						font-size: 30px;
					}
					.desc {
						font-size: 28px;
					}
				}
			}
		}
		.follow {
			padding: 40px 0;
			width: 100%;
			img {
				max-width: 50%;
			}
		}
	}
}
</style>